import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Container } from "react-bootstrap";
import Loader from "../components/Loader";
import CategoryWidget from '../components/CategoryWidget';
import "../assets/css/bootstrap.min.css";
import "../assets/css/custom.css";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const wordLimit = 50;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get("http://localhost:5000/api/users/");
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error.response ? error.response.data : error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  if (loading) return <Loader />;
  if (users.length === 0) return <p>No users available.</p>;

  const truncateText = (text, wordLimit) => {
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  return (
    <div>
      {/* Posts Filter Bar Start */}
      <div className="posts--filter-bar style--1 hidden-xs">
        <div className="container">
          <ul className="nav">
            <li>
              <a href="#">
                <i className="fa fa-star-o" />
                <span>Featured News</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-heart-o" />
                <span>Most Popular</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-fire" />
                <span>Hot News</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-flash" />
                <span>Trending News</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-eye" />
                <span>Most Watched</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      {/* Posts Filter Bar End */}

      {/* News Ticker Start */}
      <div className="news--ticker">
        <div className="container">
          <div className="title">
            <h2>News Updates</h2>
            <span>(Update 12 minutes ago)</span>
          </div>
          <div className="news-updates--list" data-marquee="true">
            <ul className="nav">
              <li>
                <h3 className="h3">
                  <a href="#">
                    Contrary to popular belief Lorem Ipsum is not simply random
                    text.
                  </a>
                </h3>
              </li>
              <li>
                <h3 className="h3">
                  <a href="#">
                    Education to popular belief Lorem Ipsum is not simply
                  </a>
                </h3>
              </li>
              <li>
                <h3 className="h3">
                  <a href="#">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  </a>
                </h3>
              </li>
              <li>
                <h3 className="h3">
                  <a href="#">
                    Corporis repellendus perspiciatis reprehenderit.
                  </a>
                </h3>
              </li>
              <li>
                <h3 className="h3">
                  <a href="#">
                    Deleniti consequatur laudantium sit aspernatur?
                  </a>
                </h3>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* News Ticker End */}

      {/* Main Breadcrumb Start */}
      <div className="main--breadcrumb">
        <div className="container">
          <ul className="breadcrumb">
            <li>
              <a href="home-1.html" className="btn-link">
                <i className="fa fm fa-home" />
                Home
              </a>
            </li>
            <li className="active">
              <span>AuthorList</span>
            </li>
          </ul>
        </div>
      </div>
      {/* Main Breadcrumb End */}

      {/* Main Content Section Start */}
      <div className="main-content--section pbottom--30">
        <div className="container">
          <div className="row">
            {/* Main Content Start */}
            <div className="main--content col-md-8 col-sm-7" data-sticky-content="true">
              <div className="sticky-content-inner">
                {/* API data start */}
                <Container className="user-list-container">
                  <div className="user-list">
                  {users.map((user) => (
                    <div key={user.id} className="user-card" onClick={() => navigate(`/users/${user.id}`)}>
                      {/* User Image */}
                      <div className="user-image">
                        <img src={user.img || "/img/307.jpg"} alt="User Avatar" /> {/* Ensure correct field name */}
                      </div>
                      
                      {/* Divider */}
                      <div className="vertical-divider"></div>
                      
                      {/* User Details */}
                      <div className="user-info">
                        <h3 className="user-name">{user.firstName} {user.lastName}</h3>
                        <p className="user-address">{user.address || "No address available"}</p>
                        <hr style={{ width: "100%", margin: "10px 0" }} /> {/* Divider below address */}
                        <p className="user-about">{user.aboutMe ? truncateText(user.aboutMe, wordLimit) : "No bio available."}</p>
                      </div>
                    </div>
                  ))}
                   
                  </div>

                  {/* CSS Styling */}
                  <style>
                    {`
                      .user-list-container {
                        max-width: 850px;
                        margin: 20px auto; /* Reduced margin to move content upward */
                        padding: 20px;
                        background: rgb(250, 250, 250);
                        border-radius: 10px;
                      }
                      .user-list {
                        display: flex;
                        flex-direction: column;
                        gap: 20px;
                      }
                      .user-card {
                        display: flex;
                        align-items: center;
                        background: rgb(241, 239, 239);
                        padding: 20px;
                        border-radius: 8px;
                        cursor: pointer;
                        transition: background 0.3s ease-in-out;
                        height: 250px;
                      }
                      .user-card:hover {
                        background: rgb(210, 210, 210);
                      }
                      .user-image img {
                        width: 100px;
                        height: 100px;
                        border-radius: 10px;
                        object-fit: cover;
                      }
                      .vertical-divider {
                        width: 2px;
                        height: 80px;
                        background: #ccc;
                        margin: 0 15px;
                      }
                      .user-info {
                        flex: 1;
                        margin-top: -100px; 
                      }
                      .user-name {
                        font-size: 18px;
                        font-weight: bold;
                        color: #333;
                        text-decoration: underline;
                      }
                      .user-address, .user-about {
                        font-size: 14px;
                        color: #666;
                      }
                      @media (max-width: 768px) {
                        .user-card {
                          flex-direction: column;
                          align-items: flex-start;
                        }
                        .vertical-divider {
                          display: none;
                    
                        }
                      }
                    `}
                  </style>
                </Container>
              </div>
            </div>
            {/* Main Content End */}

            {/* Main Sidebar Start */}
            <div className="main--sidebar col-md-4 col-sm-5 ptop--30 pbottom--30" data-sticky-content="true">
              <div className="sticky-content-inner">
                {/* Widget Start */}
                <div className="widget">
                  {/* Search Widget Start */}
                  <div className="search--widget">
                    <form action="#" data-form="validate">
                      <div className="input-group">
                        <input
                          type="search"
                          name="search"
                          placeholder="Search..."
                          className="form-control"
                          required
                        />
                        <div className="input-group-btn">
                          <button type="submit" className="btn-link">
                            <i className="fa fa-search" />
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                  {/* Search Widget End */}
                </div>
                {/* Widget End */}
                {/* Widget Start */}
                <div><CategoryWidget /></div>
                {/* Widget End */}
                {/* Widget Start */}
                <div className="widget">
                  <div className="widget--title">
                    <h2 className="h4">Tags</h2>
                    <i className="icon fa fa-tags" />
                  </div>
                  {/* Tags Widget Start */}
                  <div className="tags--widget style--1">
                    <ul className="nav">
                      <li><a href="#">News</a></li>
                      <li><a href="#">Image</a></li>
                      <li><a href="#">Music</a></li>
                      <li><a href="#">Video</a></li>
                      <li><a href="#">Audio</a></li>
                      <li><a href="#">Fashion</a></li>
                      <li><a href="#">Latest</a></li>
                      <li><a href="#">Trendy</a></li>
                      <li><a href="#">Special</a></li>
                      <li><a href="#">Recipe</a></li>
                      <li><a href="#">Sports</a></li>
                    </ul>
                  </div>
                  {/* Tags Widget End */}
                </div>
                {/* Widget End */}

                {/* Widget Start */}
                <div className="widget">
                  <div className="widget--title">
                    <h2 className="h4">Get Newsletter</h2>
                    <i className="icon fa fa-envelope-open-o" />
                  </div>
                  {/* Subscribe Widget Start */}
                  <div className="subscribe--widget">
                    <div className="content">
                      <p>
                        Subscribe to our newsletter to get latest news, popular
                        news and exclusive updates.
                      </p>
                    </div>
                    <form
                      action="https://themelooks.us13.list-manage.com/subscribe/post?u=79f0b132ec25ee223bb41835f&id=f4e0e93d1d"
                      method="post"
                      name="mc-embedded-subscribe-form"
                      target="_blank"
                      data-form="mailchimpAjax"
                    >
                      <div className="input-group">
                        <input
                          type="email"
                          name="EMAIL"
                          placeholder="E-mail address"
                          className="form-control"
                          autoComplete="off"
                          required
                        />
                        <div className="input-group-btn">
                          <button
                            type="submit"
                            className="btn btn-lg btn-default active"
                          >
                            <i className="fa fa-paper-plane-o" />
                          </button>
                        </div>
                      </div>
                      <div className="status" />
                    </form>
                  </div>
                  {/* Subscribe Widget End */}
                </div>
              </div>
            </div>
            {/* Main Sidebar End */}
          </div>
        </div>
      </div>
      {/* Main Content Section End */}
      <div id="backToTop">
        <a href="#">
          <i className="fa fa-angle-double-up"></i>
        </a>
      </div>
    </div>
  );
};

export default UserList;